import React, { FC, InputHTMLAttributes } from "react";
import { InputMask } from "./styled";

interface IDefaultMask extends InputHTMLAttributes<HTMLInputElement> {
  mask: string;
  maskChar?: string;
  err?: boolean;
}

const Default: FC<IDefaultMask> = ({
  mask,
  maskChar = "_",
  err = false,
  ...rest
}) => {
  // eslint-disable-next-line react/react-in-jsx-scope
  return <InputMask mask={mask} maskChar={maskChar} err={err} {...rest} />;
};

export default Default;
